import * as React from 'react';
import { useEffect } from 'react';
import { useKeycloak } from '@react-keycloak/web';
import { Redirect } from 'react-router-dom';
import { useRedirectTo } from '../helpers/location';

const Logout: React.FC = () => {
  const currentLocationState = useRedirectTo();

  const { keycloak } = useKeycloak();

  useEffect(() => {
    if (keycloak?.authenticated) keycloak?.logout();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keycloak?.authenticated]);

  return <Redirect to={currentLocationState.from.pathname} />;
};

export default Logout;
